module.exports = __webpack_public_path__ + "img/beaverjam-banner.bbf83562.jpg";